import { Box, Flex, Spacer, VStack } from '@chakra-ui/react'

import { EnvironmentFlag } from 'components/atoms/EnvironmentFlag'
import { useCacheFilters } from 'hooks/useCacheFilters'
import React, { memo, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { AgentAutocomplete } from '../AgentAutocomplete'
import { Help } from '../Help'
import { InstitutionAutocomplete } from '../InstitutionAutocomplete'
import { NavigationDrawer } from '../NavigationDrawer'
import { Profile } from '../Profile'
import { HeaderPros } from './interfaces'

export const Header: React.FC<HeaderPros> = memo(({ variant }) => {
    const isMobile = variant === 'mobile'
    const { pathname } = useLocation()
    const routesToDisableAutocomplete = [
        '/instituicoes',
        '/agentes-financeiros',
        '/gestao-taxas',
        '/contratos/'
    ]
    const hideInstitutionAutocomplete = routesToDisableAutocomplete.some(
        route => pathname.startsWith(route)
    )

    const { cleanCacheFilters } = useCacheFilters()

    useEffect(() => {
        cleanCacheFilters()
    }, [pathname])

    return (
        <Box>
            <Flex
                data-testid="header-content"
                bg={isMobile ? 'white' : 'transparent'}
                alignItems="center"
                p={{ base: 4, md: 6 }}
            >
                <Box data-testid="header-perfil">
                    {isMobile ? (
                        <NavigationDrawer />
                    ) : (
                        !hideInstitutionAutocomplete && (
                            <Flex gap={2} alignItems="center">
                                <InstitutionAutocomplete />
                                <AgentAutocomplete />
                            </Flex>
                        )
                    )}
                </Box>
                <Spacer />
                <Box>
                    <Flex alignItems="center" gap={2}>
                        <Box data-testid="header-help">
                            <Help />
                        </Box>
                        <Box data-testid="header-profile">
                            <Profile />
                        </Box>
                    </Flex>

                    <EnvironmentFlag />
                </Box>
            </Flex>

            {isMobile && !hideInstitutionAutocomplete && (
                <VStack
                    data-testid="header-mobile-autocomplete"
                    px={{ base: 4, md: 6 }}
                    py={2}
                    spacing={2}
                    align="stretch"
                >
                    <InstitutionAutocomplete />
                    <AgentAutocomplete />
                </VStack>
            )}
        </Box>
    )
})

// Add display name for better debugging
Header.displayName = 'Header'
